(function () {
    'use strict';

    var module = angular.module('uwAgenda.tasks');
    module.factory('TaskService', [
        '$http', 
        '$uibModalStack', 
        '$uibModal',         
        'HelperService', 
        'Task', 
        'ProtocolBroadcastService', 
        'ProtocolFilter', 
        'TaskStateEnum', 
        'SharedAgendaService', 
        'AppointmentService',
        '$translate',
        'DateService',
        '$q',
        TaskServiceFn
    ]);

    /* main task service */
    function TaskServiceFn(
        $http, 
        $uibModalStack, 
        $uibModal, 
        HelperService, 
        Task, 
        ProtocolBroadcastService, 
        ProtocolFilter, 
        TaskStateEnum, 
        SharedAgendaService, 
        AppointmentService,
        $translate,
        DateService,
        $q) {

        // make it with $http -> performance !
        var baseUrl = '/api/tasks/';

        var service = {
            query: query,
            getByAgendas: getByAgendas,
            get: get,
            deactivate: deactivate,
            save: save,
            update: update,
            state: state,
            newReaction: newReaction,
            pin: pin,
            unpin: unpin,
            getByPatient: getByPatient,
            tasks: tasks, // load tasks for quicksidebar
            confirmAndPin: confirmAndPin,
            confirmAndNotPin: confirmAndNotPin,
            show: show,
            newTask: newTask,
            newTaskForAppointment: newTaskForAppointment,
            showDeactivate: showDeactivate,
            showFinished: showFinished,
            editTask: editTask,
            saveTask: saveTask,
            updateTask: updateTask,
        };

        return service;

        // confirm and pin task
        function confirmAndPin(taskId) {
            return $http.put(baseUrl + taskId + '/confirmandpin').then(function (response) {
                return response.data;
            });
        } // confirmAndPin

        // confirm and not pin task
        function confirmAndNotPin(taskId) {
            return $http.put(baseUrl + taskId + '/confirmandnotpin').then(function (response) {
                return response.data;
            });
        } // confirmAndNotPin

        // get all tasks for ringfoon
        function tasks() {
            return $http.get(baseUrl).then(function (response) {
                return response.data;
            });
        } // tasks

        /* get all items */
        function query(userId, isToDo, date, all) {
            return $http({
                url: baseUrl + 'users/' + userId + '/' + (isToDo ? isToDo : false) + '/' + (all ? all : false),
                method: 'GET',
                params: {
                    date: HelperService.backendDate(date ? date : new Date())
                }
            }).then(function (response) { return response.data; });
        }

        /* get items of more than one user */
        function getByAgendas(ids, date, key) {
            var params = {
                ids: ids,
                date: HelperService.backendDate(date ? date : new Date()),
                key: key
            };
            return $http({
                url: baseUrl + 'agendas',
                method: 'GET',
                params: params
            }).then(function (response) { return response.data; });
        }


        /* get one item */
        function get(taskId) {
            return $http.get(baseUrl + taskId + '/agendas/' + SharedAgendaService.data.currentAgenda.id).then(function (response) { return response.data; });
        }

        /* get by patient */
        function getByPatient(patientId) {
            return $http.get(baseUrl + 'agendas/' + SharedAgendaService.data.currentAgenda.id + '/patients/' + patientId).then(function (response) { return response.data; });
        }

        /* save item */
        function save(item) {
            return $http.post(baseUrl + 'agendas/' + SharedAgendaService.data.currentAgenda.id, item).then(function (response) { return response.data; });
        }

        /* save item for an agenda */
        function saveTask(item, agendaId) {
            return $http.post(baseUrl + 'agendas/' + agendaId, item).then(function (response) { return response.data; });
        }

        /* deactivate item */
        function deactivate(id) {
            return $http.delete(baseUrl + id + '/agendas/' + SharedAgendaService.data.currentAgenda.id).then(function (result) {
                return result.data;
            });
        }

        /* update item */
        function update(taskId, item) {
            return $http.put(baseUrl + taskId + '/agendas/' + SharedAgendaService.data.currentAgenda.id, item).then(function (response) { return response.data; });
        }

        /* update item for an agenda*/
        function updateTask(taskId, item, agendaId) {
            return $http.put(baseUrl + taskId + '/agendas/' + agendaId, item).then(function (response) { return response.data; });
        }

        /* add new reaction / comment */
        function newReaction(taskId, taskState, reaction, pin) {
            return $http.post(baseUrl + taskId + '/agendas/' + SharedAgendaService.data.currentAgenda.id + '/reaction/' + taskState+ '/'+ (pin ? 'true': 'false'), reaction).then(function (response) { return response.data; });
        }

        /* update state */
        function state(taskId, state, flag, pin, pinDate, isImportant) {
            return $http.put(baseUrl + taskId + '/agendas/' + SharedAgendaService.data.currentAgenda.id + '/state', { state: state, flag: flag, pin:pin, pinDate: pinDate, isImportant: isImportant }).then(function (response) {
                return response.data;
            });
        }

        /* pin task to given date and create reaction */
        function pin(taskId, date) {
            return $http({
                url: baseUrl + taskId + '/agendas/' + SharedAgendaService.data.currentAgenda.id + '/pin',
                method: 'PUT',
                params: {
                    date: HelperService.backendDate(date ? date : new Date())
                }
            }).then(function (result) {
                return result.data;
            });
        }

        /* unpin task from date and create reaction */
        function unpin(taskId) {
            return $http.put(baseUrl + taskId + '/agendas/' + SharedAgendaService.data.currentAgenda.id + '/unpin').then(function (result) {
                return result.data;
            });
        }

        // Show Task-Information 
        function show(id) {
            // close other modals
            $uibModalStack.dismissAll();

            // load the task 
            get(id).then(function (result) {
                // edit - create new object and extend
                var toShow = new Task();
                toShow.extend(result);

                // show modal
                return $uibModal.open({
                    backdrop: true,
                    keyboard: true,
                    animation: true,
                    windowClass: 'modal-to-right',
                    templateUrl: '/app/tasks/templates/task-info.template.html',
                    controller: 'TaskInfoController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        task: function () {
                            return toShow;
                        }
                    }
                });
            });

        } // show

        // show the modal to deactivate item
        function showDeactivate(id) {
            // open modal
            var modalInstance = HelperService.deactivatingConfirmationModal();

            // when modal is closed
            return modalInstance.result.then(function () {
                return deactivate(id);
            }, function () {
                // dismissed
                return;
            });
        }


        // show the modal to finish item
        function showFinished(id) {
            // open modal
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                animation: true,
                templateUrl: '/app/tasks/templates/finish-task-modal.template.html',
                controller: 'ItemDeactivatingController',
                controllerAs: 'vm',
                size: 'xs'
            });

            // when modal is closed
            return modalInstance.result.then(function () {
                return state(id, TaskStateEnum.Finished.value, null, true, DateService.data.date);
            }, function () {
                // dismissed
                return;
            });
        }
        


        // New Task
        function newTask(isToDo, preparedTask) {
            //If a protocol that needs to be shown when creating a daynote exists
            if (ProtocolFilter.ShowOnDayTaskAdd){
                ProtocolBroadcastService.broadcast(ProtocolFilter.ShowOnDayTaskAdd);
            }
            // open modal
            let modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                animation: true,
                templateUrl: '/app/tasks/templates/task-detail.template.html',
                controller: 'TaskDetailController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    task: function () {
                        // if a Task was passed to this function => show that task
                        if (preparedTask) {
                            return preparedTask;
                        } else {   // else: create a new task 
                            return new Task(isToDo);
                        }

                    }
                }
            });

            return modalInstance.result;
        } // newTask

        // New Task
        function newTaskForAppointment(appointmentId) {

            var deferred = $q.defer();

            var agendaId = SharedAgendaService.data.currentAgenda.id;

            AppointmentService
                        .get(appointmentId, agendaId)
                        .then(function(appointment) {
                            // create task, based on appointment
                            var task = new Task(false);
                            task.fK_Appointment = appointmentId;
                            task.fK_Agenda = agendaId;
                            task.fK_User = SharedAgendaService.getLoggedInUserData().id;
                            task.fK_Patient = appointment.patient.id;
                            task.patientDto = appointment.patient;
                            task.taskState = TaskStateEnum.InProgress.value;
                            // task.pinnedToDate = appointment.appointmentDate;

                            var patient = appointment.patient;
                            var content = patient.caption;
                            if (patient.birthday) {
                                content += ` (${moment(patient.birthday).format('DD/MM/YYYY')})`;
                            }
                            if (patient.mainMobileNumber) {
                                content += `, ${patient.mainMobileNumber}`;
                            } else if (patient.mainPhoneNumber) {
                                content += `, ${patient.mainPhoneNumber}`;
                            } else if (patient.mainEmail) {
                                content += `, ${patient.mainEmail}`;
                            }

                            var appDate = moment(appointment.appointmentDate);
                            content += ` - ${$translate.instant('Appointment_At')} ${appDate.format('dddd DD MMMM YYYY H:mm')} `;
                                                     
                            task.content = content;

                            newTask(false, task).then(function() {
                                deferred.resolve(task);
                            }, function() {
                                deferred.reject();
                            });
                        });

                return deferred.promise;
        }


        // Edit Task
        function editTask(id) {
            // close all possibly open modals
            $uibModalStack.dismissAll();

            // modal 
            var modalInstance = null;
            // load the task 
            get(id).then(function (result) {
                // edit - create new object and extend
                var toEdit = new Task();
                toEdit.extend(result);

                // open modal
                modalInstance = $uibModal.open({
                    backdrop: 'static',
                    keyboard: false,
                    animation: true,
                    templateUrl: '/app/tasks/templates/task-detail.template.html',
                    controller: 'TaskDetailController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        task: function () {
                            return toEdit;
                        }
                    }
                });

                // when modal is closed
                modalInstance.result.then(function (task) {
                }, function () {
                    //dismissed
                });
            });
        } // editTask


    }
})();